import {
  EnumTipoDomandaModuloDTOTipoAssociazione,
  type RichiestaModuloDTO,
} from '@framework/api-client';

/**
 * Restituisce il modulo principale dall'elenco dei moduli.
 */
export function getPrincipalModule(modules: RichiestaModuloDTO[]) {
  return modules.find(
    m =>
      m.domandaModulo?.tipoAssociazione ===
      EnumTipoDomandaModuloDTOTipoAssociazione.PRINCIPALE,
  );
}
